module.exports = __webpack_public_path__ + "img/sign-40.96198850.jpg";